import React, { useState, useEffect } from "react";
import axios from "axios";
import { Users, ShoppingBag, Calendar, TrendingUp } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

const VIP_COLORS = { Diamond: "#B9F2FF", Platinum: "#E8E8E8", Gold: "#C5A059", Silver: "#C0C0C0", Standard: "#888" };

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/admin/stats`, { withCredentials: true }).then(r => setStats(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  if (loading) return <div style={{ fontFamily: "Manrope", color: "#888", padding: "40px 0", textAlign: "center" }}>Загрузка...</div>;
  if (!stats) return <div style={{ color: "#dc2626", fontFamily: "Manrope" }}>Ошибка загрузки</div>;

  const cards = [
    { label: "Клиентов всего", value: stats.total_clients, icon: Users, color: "#C5A059" },
    { label: "Товаров в каталоге", value: stats.total_products, icon: ShoppingBag, color: "#60a5fa" },
    { label: "Новых записей", value: stats.pending_appointments, icon: Calendar, color: "#4ade80" },
    { label: "Общий оборот", value: `${(stats.total_revenue / 1000000).toFixed(1)} M ₸`, icon: TrendingUp, color: "#e879f9" },
  ];

  return (
    <div>
      {/* Stats Grid */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(180px,1fr))", gap: "16px", marginBottom: "32px" }}>
        {cards.map(({ label, value, icon: Icon, color }) => (
          <div key={label} data-testid={`stat-${label}`} style={{ background: "white", border: "1px solid #e5e7eb", borderRadius: "8px", padding: "20px", display: "flex", alignItems: "flex-start", gap: "12px" }}>
            <div style={{ width: "40px", height: "40px", borderRadius: "8px", background: `${color}15`, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
              <Icon size={18} style={{ color }} />
            </div>
            <div>
              <div style={{ fontFamily: "Cormorant Garamond", fontSize: "26px", color: "#0A0A0A", fontWeight: 600, lineHeight: 1 }}>{value}</div>
              <div style={{ fontFamily: "Manrope", fontSize: "11px", color: "#888", marginTop: "4px" }}>{label}</div>
            </div>
          </div>
        ))}
      </div>

      {/* VIP Breakdown */}
      <div style={{ background: "white", border: "1px solid #e5e7eb", borderRadius: "8px", padding: "24px" }}>
        <h3 style={{ fontFamily: "Cormorant Garamond", fontSize: "20px", color: "#0A0A0A", fontWeight: 400, marginBottom: "20px" }}>Распределение VIP уровней</h3>
        <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          {Object.entries(stats.vip_counts || {}).map(([level, count]) => {
            const total = Object.values(stats.vip_counts || {}).reduce((s, c) => s + c, 0);
            const pct = total > 0 ? Math.round((count / total) * 100) : 0;
            const color = VIP_COLORS[level] || "#888";
            return (
              <div key={level}>
                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "4px" }}>
                  <span style={{ fontFamily: "Manrope", fontSize: "13px", fontWeight: 600, color: color }}>{level}</span>
                  <span style={{ fontFamily: "Manrope", fontSize: "13px", color: "#666" }}>{count} чел. ({pct}%)</span>
                </div>
                <div style={{ background: "#f1f5f9", borderRadius: "4px", height: "6px" }}>
                  <div style={{ width: `${pct}%`, height: "100%", background: color, borderRadius: "4px", transition: "width 1s ease" }} />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
